import 'monaco-editor';
import DefaultEditorWorker from 'monaco-editor/esm/vs/editor/editor.worker?worker';
import JsonEditorWorker from 'monaco-editor/esm/vs/language/json/json.worker?worker';
import TsEditorWorker from 'monaco-editor/esm/vs/language/typescript/ts.worker?worker';
import { BrowserClipboardService } from 'monaco-editor/esm/vs/platform/clipboard/browser/clipboardService.js';

// Disable Monaco's WebKit clipboard workaround. On Safari/iOS, Monaco installs
// body-level `click` and `keydown` listeners that wrap `navigator.clipboard.write()`
// in a deferred promise. Each new event cancels the previous deferred, which causes
// the previous `clipboard.write()` to reject with a `CancellationError` that Monaco
// then logs as `ERR Canceled`. The result is noise on every tap/keypress on mobile.
// We don't use Monaco's clipboard layer (see `app/grid/actions/clipboard/clipboard.tsx`),
// so the workaround is unnecessary and we no-op it here. Must run before any editor is
// created so the patched prototype is used when `BrowserClipboardService` is instantiated.
BrowserClipboardService.prototype.installWebKitWriteTextWorkaround = function () {};

window.MonacoEnvironment = {
  getWorker(_, label) {
    switch (label) {
      case 'typescript':
      case 'javascript':
        return new TsEditorWorker({ name: label });
      case 'json':
        return new JsonEditorWorker({ name: label });
      default:
        return new DefaultEditorWorker({ name: label });
    }
  },
};
